import { SyncStatusLastSyncedText } from "@/components/sync/sync-status-last-synced-text";
import { OutboundSyncStatus, SyncState } from "@/components/sync/types";
import { pluralize } from "@/modules/pluralize";
import { observer } from "mobx-react-lite";

interface Props {
  syncState: SyncState;
}

export const SyncStatusText = observer(({ syncState }: Props) => {
  const count = syncState.pendingOperationCount;
  const { status, inboundLastSyncedAt, outboundLastSyncedAt } = syncState;

  switch (status) {
    case OutboundSyncStatus.Idle:
      return (
        <SyncStatusLastSyncedText
          inboundLastSyncedAt={inboundLastSyncedAt}
          outboundLastSyncedAt={outboundLastSyncedAt}
        />
      );

    case OutboundSyncStatus.Syncing:
      return (
        <div>
          Syncing {count} {pluralize(count, "change", "changes")}
        </div>
      );
    case OutboundSyncStatus.Paused:
      return (
        <div>
          {count} {pluralize(count, "change", "changes")} will sync <br /> when Mem reconnects
        </div>
      );
  }
});
